import moment from 'moment';
import Currency from './models/currency';
export const DEFAULT_HOUR = 3;
export const DAY_MS = 1000 * 3600 * 24;
export const SecondsInYear = 31556926;
export const DateFormat = 'DD.MM.YYYY';
export const DateTimeFormat = 'DD.MM.YYYY HH:mm';
export const TimeFormat = 'HH:mm';
export const deserializeDate = (date, defaultValue = new Date()) => date ? new Date(date) : defaultValue;
export const deserializeNumber = (number, defaultValue = 0) => number || defaultValue;
export const deserializeString = (string, defaultValue = '') => string || defaultValue;
export const today = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), DEFAULT_HOUR, 0);
};
export const yesterday = () => {
    const now = today();
    return new Date(now.getTime() - DAY_MS);
};
export const weekAgo = () => {
    const now = today();
    return new Date(now.getTime() - (7 * DAY_MS));
};
export const tommorow = () => {
    const now = today();
    return new Date(now.getTime() + DAY_MS);
};
export const formatDate = (date) => {
    return moment(date).format(DateFormat);
};
export const parseDate = (date) => {
    return moment(date || new Date(1).toISOString(), DateFormat).toDate();
};
export const formatTime = (date) => {
    return moment(date).format(TimeFormat);
};
export const formatDateTime = (date) => {
    return moment(date).format(DateTimeFormat);
};
export const euro = new Currency({
    code: 'eur',
    name: 'Euro',
    symbol: '€'
});
export const formatPrice = (price, currency = euro) => {
    const elements = [];
    if (price === null) {
        elements.push('0.00');
    }
    if (typeof price === 'number') {
        elements.push((price || 0).toFixed(2));
    }
    else if (typeof price === 'string') {
        elements.push((parseFloat(price)).toFixed(2));
    }
    else if (price !== null) {
        elements.push(price.round(2).getValue());
    }
    elements.push(currency.symbol);
    return elements.join(' ');
};
export const hasString = (string, minLength = 1) => {
    return string.length >= minLength;
};
export const hasStrings = (strings, minLength = 1) => {
    let valid = true;
    for (let i = 0; i < strings.length; i++) {
        if (!hasString(strings[i])) {
            valid = false;
            break;
        }
    }
    return valid;
};
export const hexToRGBA = (hex, opacity) => {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r},${g},${b}, ${opacity / 100})`;
};
export const capitalize = (s) => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase();
export const download = (url, token) => {
    const link = document.createElement('a');
    let path = `${window.location.origin}${url}`;
    if (token) {
        let symbol = url.match(/\?/) ? '&' : '?';
        path += `${symbol}token=${token}`;
    }
    link.href = path;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
export const diffMonths = (dt2, dt1) => {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7 * 4);
    return Math.abs(Math.round(diff));
};
export const diffDays = (date1, date2) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};
export function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onloadend = (e) => {
            resolve(e.target.result);
        };
        reader.readAsDataURL(file);
    });
}
//# sourceMappingURL=common.js.map